import { Component, EventEmitter, Inject, Input, OnChanges, OnDestroy, OnInit, Optional, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { countProvider, WIDGET_DATA } from 'src/app/components/suggestions/suggestions.component';
import { ApiService } from 'src/app/services/api.service';
import { CommonValues } from 'src/app/services/commonValues';
import { UtilService } from 'src/app/services/util.service';
import Swal from 'sweetalert2';
import { WidgetService } from './../../services/widget.service';
import { UserCardConfig } from './../../types/UserCardConfig';
import { CommonSkeletonComponent } from '../../skeleton/common-skeleton/common-skeleton.component';
import { CommonProfileInfoComponent } from '../common-profile-info/common-profile-info.component';
import { UserCardComponent } from '../../components/cards/user-card/user-card.component';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: 'app-people-you-may-know',
  standalone: true,
  imports: [
    CommonModule,
    InfiniteScrollModule,
    CommonSkeletonComponent,
    CommonProfileInfoComponent,
UserCardComponent
  ,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './people-you-may-know.component.html',
  styleUrls: ['./people-you-may-know.component.scss']
})
export class PeopleYouMayKnowComponent implements OnInit, OnChanges, OnDestroy {
  loadAPIcall:boolean=true
  @Input('title') title: string = 'People you may know';
  @Input('open') open: boolean = true;
  @Input() userDataInput: any;
  headerTitle: string = 'People you may know';
  user: any = [{ a: 1 }, { a: 2 }, { a: 3 }, { a: 4 }];
  peopleData: any = [];
  commonDatahide: any = {}
  // Support both @Output EventEmitter and @Input callback function for NgComponentOutlet
  @Output() commonFunction: any = new EventEmitter<string>();
  @Input() maxMin: any = {};
  viewType: string = "MIN";
  @Input() page: string;
  @Input() inputData: string;
  userCardConfig: UserCardConfig[] = []
  showUI = false;
  stopScroll : boolean = false;
  prevAfterkey : string = "";
  UserdataPeople: any = [];
  clickEventsubscription: Subscription;
  values: any = {};
  pathdata: any;
  @Input() widgetDesc: string;
  @Input() suggestion: any;
  obj: any = {
    limit: 12,
    userId: localStorage.getItem('userId'),
    searchAfterKey: null
  }
  constructor(private auth: ApiService, private route: ActivatedRoute,
    private provider : countProvider ,private commonvalues: CommonValues, private router: Router, private util: UtilService, private widget: WidgetService,
    @Optional() @Inject(WIDGET_DATA) private widgetData: any) {
    // Apply injected widget data (Angular 15 NgComponentOutlet pattern)
    if (this.widgetData) {
      if (this.widgetData.maxMin) {
        this.maxMin = this.widgetData.maxMin;
        if (this.widgetData.maxMin.viewType) {
          this.viewType = this.widgetData.maxMin.viewType;
        }
      }
      if (this.widgetData.widgetDesc) {
        this.headerTitle = this.widgetData.widgetDesc;
      }
      if (this.widgetData.inputData) {
        this.inputData = this.widgetData.inputData;
      }
      if (this.widgetData.page !== undefined) {
        this.page = this.widgetData.page;
      }
    }
  }
  totalCount: any;
  configlist = {
    itemsPerPage: 5,
    currentPage: 1
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Handle maxMin changes - critical for showing MAX view on suggestions page
    if (changes.maxMin) {
      const newMaxMin = changes.maxMin.currentValue;
      if (newMaxMin) {
        this.maxMin = newMaxMin;
        if (newMaxMin.viewType) {
          this.viewType = newMaxMin.viewType;
        }
      }
    }
    // Handle widgetDesc changes for NgComponentOutlet compatibility
    if (changes.widgetDesc && changes.widgetDesc.currentValue) {
      this.headerTitle = changes.widgetDesc.currentValue;
    }
  }

  ngOnInit() {
    // Set headerTitle from widgetDesc if available (ngOnChanges handles dynamic updates)
    if (this.widgetDesc != null && this.widgetDesc !== '') {
      this.headerTitle = this.widgetDesc;
    }
    // Keep default headerTitle ('People you may know') if widgetDesc not provided
    // this.hide(true);
    if (this.maxMin.viewType != undefined) {
      this.viewType = "MAX";
      this.inputData = this.maxMin.master;
    }


    this.getUser();
    //  this.getUserData();
    this.clickEventsubscription = this.commonvalues
      .getbusinessid()
      .subscribe((res) => {
        this.values = res;
      });



    this.route.queryParams.subscribe((res) => {
      this.pathdata = res.count;
      if (res.master && res.master != "NETWORK" && res.master != "TEAM" && res.menu != null && res.menu != undefined) {

        this.headerTitle = res.menu;
      }
      this.totalCount = this.pathdata;
    })

  }


ngOnDestroy(): void {
    if(this.clickEventsubscription) {
      this.clickEventsubscription.unsubscribe();
    }
}

  modelopen(data) {
    let dataPass: any = {};
    dataPass.data = data;
    dataPass.menu = this.headerTitle || this.widgetDesc || 'People you may know';
    dataPass.master = this.page;
    dataPass.masterMenu = this.inputData;
    dataPass.widgetName = "PeopleYouMayKnowComponent";
    dataPass.count = this.totalCount;
    this.router.navigate(['suggestions'], { queryParams: dataPass })

  }



  pagecount(event) {
    this.configlist.currentPage = event;
    this.page = event;
    this.loadData(this.page);
  }

  loadData(count) {

    this.util.startLoader();
    let num: number;
    num = count - 1;
    this.peopleData = [];
    this.auth.query('widget/user/suggestion?userId=' + localStorage.getItem('userId') + "&page=" + num + "&size=8").subscribe((res) => {
      this.UserdataPeople = [];
      if (res.data.peopleYouMayKnowList != null && res.data.peopleYouMayKnowList.length !== 0) {
        this.util.stopLoader();

        this.UserdataPeople = res.data.peopleYouMayKnowList;
        res.data.peopleYouMayKnowList.forEach(element => {

          element.name = element.firstName + " " + element.lastName;

        });
        this.showUI = true;
        this.totalCount = this.pathdata;
      } else {
        this.util.stopLoader();
      }
    }, err => {
      this.util.stopLoader();


    });
  }

  refreshPeopleMayYouKnow() {
    this.loadAPIcall=true
    this.obj.searchAfterKey=null
    this.getUser();
  }



  onScrollDown(){
    if (!this.stopScroll && this.obj.searchAfterKey != this.prevAfterkey) {
      this.loadAPIcall = true;
      this.obj.searchAfterKey = this.prevAfterkey === null ? null
      : this.prevAfterkey;
      this.getUser();
    }
  }
  getUser() {

    this.auth.create("widget/user/suggestion", this.obj).subscribe((res) => {
      this.loadAPIcall = false;
      this.util.stopLoader();
      if (!res) { return; }
      if (res.data != null) {
        const resData = res.data.peopleYouMayKnowList;
        const afterKey = res.data.searchAfterKey && res.data.searchAfterKey;
        if (resData) {
          if (this.prevAfterkey === afterKey || resData.length === 0) {
            this.stopScroll = true;
          }

          resData.forEach(element => {
            element.name = element.firstName + " " + element.lastName;
            if (element.userType) {
              element.typeofuser = element.userType.replaceAll("_", " ");
            }
          });
          if (this.obj.searchAfterKey == null) {
            this.UserdataPeople = [];
          }
          this.UserdataPeople = this.UserdataPeople.concat(resData);
          this.prevAfterkey = afterKey;
          if (res.data.totalCount != undefined) {
            this.totalCount = res.data.totalCount;
            this.provider.setCount(this.totalCount , "PeopleYouMayKnowComponent");
          }
          this.showUI = true;
          this.hide(false);
        }
      }


    }, err => {
      this.loadAPIcall=false
      this.util.stopLoader();
      this.hide(true)
    });
  }




  connect(user: any) {
    this.util.startLoader();
    this.widget.connectService(user.userId).subscribe(conData => {
      this.util.stopLoader();
      if (conData.code === '00000') {
        this.widget.removeUserConnectionSuggesion(user.userId).subscribe(res => {
          if (res.code === '00000') {
            this.getUser();
          }
        })
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: "Connection request",
          text: 'Connection request sent successfully',
          showConfirmButton: false,
          timer: 2000
        })
      } else if (conData.code === '88888') {
        // Swal.fire('Connection request failed');
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: "Connection request",
          text: 'Connection request failed. Please try again later.',
          showConfirmButton: false,
          timer: 3000
        })
      }
    });
  }


  // MAX view: app-user-card sends user/connect itself and only emits handleEvent,
  // so drop the requested user from the list and from the server-side suggestions.
  onCardEvent(e: any) {
    if (!e || e.event !== 'Connection request sent successfully' || !e.data) { return; }
    const userId = e.data.userId;
    const before = this.UserdataPeople.length;
    this.UserdataPeople = this.UserdataPeople.filter(u => u.userId !== userId);
    if (this.UserdataPeople.length < before && this.totalCount > 0) {
      this.totalCount = this.totalCount - 1;
      this.provider.setCount(this.totalCount, "PeopleYouMayKnowComponent");
    }
    this.widget.removeUserConnectionSuggesion(userId).subscribe();
  }

  hide(flag) {
    // this.commonDatahide.widgetName = "PeopleYouMayKnowComponent";
    // this.commonDatahide.hide = flag;
    // this.commonFunction.emit(this.commonDatahide);
  }
}
